import { render, staticRenderFns } from "./productUpsell.vue?vue&type=template&id=7a2ee5bb"
import script from "./productUpsell.vue?vue&type=script&lang=ts"
export * from "./productUpsell.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports